import React from "react"
import { Link, graphql, useStaticQuery } from 'gatsby'
import { colorCode } from "../../functions/middle-category-style"
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"

export const ArticleArea = () => {
  const data = useStaticQuery (
    graphql`
    query ArticleAreaQuery {
        popularTags: allMicrocmsTags(
        filter: {type: {eq: "人気のタグ"}, referenced_note_tag: {type: {eq: "ノートタグ"}}}
        ) {
        edges {
          node {
            referenced_note_tag {
              id
              name
            }
          }
        }
      }

      hotArticles: allMicrocmsNotes(
        limit: 3
        sort: {fields: [publishedAt], order: DESC}
      ) {
        edges {
          node {
            notesId
            title
            middle_category {
              id
              name
              display_color
            }
            thumbnail {
              url
            }
          }
        }
      }
    }`
  )

  return (
    <>
    <div className="contents_articleArea">
      <div className="contents_in">
        <div className="padding_sp">{/* スマホのみ隙間 */}
          <div className="articleArea_wrap">
            <ul className="articleArea_box">
              <li className="box tag">
                <div className="inner_title">
                  <div className="inner_title_in">
                    <p className="subtitle"><span>人気のタグ</span></p>
                    <h4 className="maintitle"><span>Popular Tags</span></h4>
                  </div>
                </div>
                <ul className="in_box">
                  <li className="tag">
                    <ul>
                      {data.popularTags.edges.map(({ node }) => (
                        <li key={node.referenced_note_tag.id}><Link to={'/note/tag/' + node.referenced_note_tag.name}>#{node.referenced_note_tag.name}</Link></li>
                      ))}
                    </ul>
                  </li>
                </ul>
              </li>
              <li className="box articles">
                <div className="inner_title">
                  <div className="inner_title_in">
                    <p className="subtitle"><span>注目の記事</span></p>
                    <h4 className="maintitle"><span>Hot Articles</span></h4>
                  </div>
                </div>
                <div className="scroll_sp sp_scroll_x">
                  {data.hotArticles.edges.map(({ node }) => (
                    <div className="box_wrap clearfix" key={node.notesId}>
                      <div className="articleImg"><Link to={'/note/' + node.notesId}><LazyAndPreloadImage imgUrl={node.thumbnail ? node.thumbnail.url : ''} alt="注目の記事" /></Link></div>
                      <div className="box">
                        <p className="articles pc_only"><Link to={'/note/' + node.notesId}>{node.title}</Link></p>
                        { node.middle_category ?
                          <Link to={'/note/category/' + node.middle_category.name}>
                            <div className="case_study_icon single" style={{background: colorCode(node.middle_category.display_color ? node.middle_category.display_color[0] : '')}}>{node.middle_category.name}</div>
                          </Link>

                          : ''
                        }
                        <p className="articles sp_only"><Link to={'/note/' + node.notesId}>{node.title}</Link></p>
                      </div>
                    </div>
                  ))}
                </div>
              </li>
            </ul>
          </div>
        </div>{/* padding_sp スマホのみ隙間 */}
      </div>{/* contents_in */}
    </div>{/* /contents_articleArea */}
    </>
  )
}

export default ArticleArea
